const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        mode: 'snap',
        slides: {
          perView: 1.8,
          spacing: 1,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.7,
              spacing: 1,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: this.displayedCards,
              spacing: 1,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }

  get displayedCards () {
    return Math.min(Number(this.dataset.slides) || 4.5, 6.2)
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
